import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { introduceTabData } from '../../components/Tab/TabData';

import ToggleLanguage from '../../components/ToggleLanguage';
import { fetchGet } from '../../hooks/fetch';
import useLanguage from '../../hooks/useLanguage';
import Loading from '../Loading';

export default function Map() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '찾아오시는 길';

	const [activeLanguage, handleSelctLanguage] = useLanguage({});

	const [post, setPost] = useState({});
	
	function getPage() {
		fetchGet(
			`/introduction/basic?type=MAP&language=${activeLanguage}`,
			(json) => {
				setPost(json.response);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getPage();
	}, [activeLanguage]);

	return (
		<main id="introduce-page-wrap" className="map-page">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={introduceTabData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
						<ToggleLanguage index={activeLanguage} onChange={handleSelctLanguage} />
					</div>

					<div>
						{isLoading ? <Loading />
									: <div dangerouslySetInnerHTML={{ __html: post?.content }}/>}
					</div>
				</div>
			</Container>
		</main>
	);
}
